import { useEffect, useState } from "react";
import { useLocation, useMatch } from "react-router-dom";

import { paths } from "@/paths";

export type UsePageTypeResult = {
  type: string;
  path: string;
  search: string;
};

export const usePageType = () => {
  const { pathname } = useLocation();
  const [pageType, setPageType] = useState<UsePageTypeResult | undefined>(
    undefined
  );

  const matchUnitPack = useMatch(paths.SCHEME_LEARNING_SEQUENCE_PATH);
  const matchCurriculumList = useMatch(paths.CURRICULUM_LIST_PATH);
  const matchCurriculumOverview = useMatch(paths.CURRICULUM_SUBJECT_LIST_PATH);
  const matchExploreSubjects = useMatch(
    paths.EXPLORE_SCHEME_LIST_CONTENTS_PATH
  );
  const matchExploreSubjectScheme = useMatch(
    paths.EXPLORE_SUBJECT_CONTENTS_SCHEME_PATH
  );
  const matchCurriculumGoal = useMatch(paths.CURRICULUM_GOAL_PATH);

  const matchSubjectPlanUnit = useMatch(paths.SUBJECT_PLAN_EDIT_PATH);
  const matchSubjectPlanOverview = useMatch(paths.SUBJECT_PLAN_OVERVIEW_PATH);

  useEffect(() => {
    if (matchCurriculumList) {
      setPageType({
        type: "App: Curriculum Architect Your Curricula",
        path: pathname,
        search: location.search,
      });
    } else if (matchSubjectPlanUnit) {
      setPageType({
        type: "App: Curriculum Architect - Plan Units",
        path: pathname,
        search: location.search,
      });
    } else if (matchSubjectPlanOverview) {
      setPageType({
        type: "App: Curriculum Architect - Planner Overview",
        path: pathname,
        search: location.search,
      });
    } else if (matchUnitPack) {
      setPageType({
        type: "App: Curriculum Architect - Learning Sequence",
        path: pathname,
        search: location.search,
      });
    } else if (matchCurriculumOverview) {
      setPageType({
        type: "App: Curriculum Architect - Curriculum Overview",
        path: pathname,
        search: location.search,
      });
    } else if (matchExploreSubjects) {
      setPageType({
        type: "App: Curriculum Architect - Explore Scheme Content",
        path: pathname,
        search: location.search,
      });
    } else if (matchExploreSubjectScheme) {
      setPageType({
        type: "App: Curriculum Architect - Scheme Units",
        path: pathname,
        search: location.search,
      });
    } else if (matchCurriculumGoal) {
      setPageType({
        type: "App: Curriculum Architect - Curriculum Goals",
        path: pathname,
        search: location.search,
      });
    } else {
      setPageType(undefined);
    }
  }, [
    pathname,
    matchCurriculumGoal,
    matchCurriculumList,
    matchCurriculumOverview,
    matchExploreSubjectScheme,
    matchExploreSubjects,
    matchSubjectPlanUnit,
    matchUnitPack,
    matchSubjectPlanOverview,
  ]);

  return {
    pageType,
  };
};
